import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';

import { AuthService } from 'app/core/auth/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    return new Promise(async (resolve) => {
        let result = await inject(AuthService).checkAuthentication();
        resolve(!!result);
    });
};
